import { configure } from 'react-hotkeys';
import config from 'mangools-commons/dist/configs/reactHotkeys';

configure(config);
